<template>
  <div :class="divWidthChange" class="conteudoWidth fccUsuarios">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row" v-if="permissao">
      <div class="col-sm-12">
        <toggle-button @change="editandoLstGrupo" v-model="permissaoGrupos" :sync="true" />
        Acessar grupos externos
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsGrupo"
          :status="statusGrupo"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsGrupo"
          addFilter
          :items="grupoListando"
        >
        </fccTable>

        <fccPermissoes
          title="Permissões do grupo "
          :DataItem="permissaoGrupo"
          :nomeAdmin="nomeGrupo"
          :titlePage="titleGrupo"
          idModal="listaPermissao"
          TipoTabela="1"
          :dataTable="usuariosDoGrupo"
          respostaNegativa="Não há usuários nesse grupo"
        ></fccPermissoes>
      </div>
    </div>
    <fccModal
      centered
      idModal="editGrupo"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="grupo.perid === 0 ? adicionandoGrupo() : editandoGrupo()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <input type="hidden" v-model="grupo.perid" />
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="grupo.pernome" required>Nome</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="grupo.perdescricao" required
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-3">
            <label>Ativo</label><br />
            <toggle-button v-model="grupo.perativo" />
          </div>
          <div class="col-sm-3">
            <label>Temporário</label><br />
            <toggle-button v-model="grupo.pertemporario" />
          </div>
          <div class="col-sm-3">
            <label>Setor</label><br />
            <toggle-button v-model="grupo.perflsetor" />
          </div>
          <div class="col-sm-3">
            <label>Externo</label><br />
            <toggle-button v-model="grupo.perexterno" :disabled="!permissao" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccPermissoes from '../../../fccComponents/fccListaPermissoes.vue'
import './../assets/fccUsuarios.scss'

export default {
  components: { fccPermissoes },
  data() {
    return {
      nomeGrupo: '',
      usuariosDoGrupo: [],
      titleGrupo: 'Usuários do Grupo',
      permissaoGrupo: [],
      statusGrupo: [
        {
          funcaoButton: 'changeGrupo',
          tooltip: 'Alterar Status',
          campoStatus: 'perativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsGrupo: [
        { key: 'perid', label: 'ID', sortable: true, active: true },
        { key: 'pernome', label: 'Nome', sortable: true, active: true },
        {
          key: 'pertemporario',
          label: 'Temporário',
          active: true,
          funcaoButton: 'changeGrupo',
          type: 'toggle',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        { key: 'status', label: 'Status', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actionsGrupo: [
        {
          button: true,
          funcaoButton: 'subGrupo',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteGrupo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'listaPermissaoGrupos',
          icon: 'lock',
          tooltip: 'Permissões',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      permissao: {},
      baseUrlSeguranca: '',
      fechaPesquisa: '',
      sortBy: 'ordem',
      titlePage: 'Grupos',
      permissaoGrupos: false,
      titleModal: '',
      grupo: {},
      formActive: 0,
      titlePDF: 'Grupos',
      itemPorPage: '100'
    }
  },
  methods: {
    listaPermissaoGrupos: function (_, item) {
      this.nomeGrupo = item.perdescricao
      this.listarUsuariosDoGrupo(item.perid)

      this.$root.$emit('bv::show::modal', 'listaPermissao')
    },

    listarPermissaoPorGrupo(id) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Menu/listarmenugrupo?perID=' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.permissaoGrupo = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editandoLstGrupo() {
      this.gruposListando(!this.permissaoGrupos)
    },
    listarUsuariosDoGrupo(id) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listarusuariogrupoporpai/' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.usuariosDoGrupo = response.data
          this.listarPermissaoPorGrupo(id)
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    changeGrupo: function (_, item) {
      this.grupo = item
      this.editandoGrupo()
    },
    subGrupo: function (_, item) {
      this.$router.push({ path: '/seguranca/grupos/sub/' + item.perid })
    },
    deleteGrupo: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.pernome).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Perfil/excluirperfil?perID=' + item.perid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.gruposListando(this.permissao)
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editandoGrupo: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'Perfil/alterarperfil',
          this.grupo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.grupo = {}
          this.carregaTexto()
          this.gruposListando(this.permissao)
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editGrupo')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    addField: function () {
      this.titleModal = 'Adicionar Grupo'
      this.grupo = {}
      this.grupo.perid = 0
      this.grupo.perativo = true
      this.grupo.perexterno = true
      this.$root.$emit('bv::show::modal', 'editGrupo')
    },
    adicionandoGrupo: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSeguranca + 'Perfil/incluirperfil',
          this.grupo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.carregaTexto()
          this.gruposListando(this.permissao)
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.grupo = {}
          this.$root.$emit('bv::hide::modal', 'editGrupo')
          this.$router.push({ path: '/seguranca/grupos/sub/' + response.data })
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.permissao = this.permissaoPage.filter((lista) => lista.objpermcodigo === 'X').length > 0

    this.gruposListando(this.permissao)
  }
}
</script>
